import {
  Checkbox,
  FormControlLabel,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { createColumns } from "actions/columns/createColumns";
import TitleSectionModal from "components/TitleSectionModal";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import JobDetailModalWrap from "views/JobDetailPage/JobDetailModalWrap";
import { CellLabel } from "views/ProjectGroupPage/RightPart/AllProjectTable/constants/Columns";
import SelectFieldTypeDropdown from "./Dropdown";
import TabContentColumn from "./TabContentColumn";
import TitleModalAdd from "./TitleModalAdd";
import ToggleInput from "./ToggleInput";
import { useGetLibraryList, createColFromLibrary } from "../hooks";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { listColumns } from "actions/columns/listColumns";
import ModalCommon from "components/ModalCommon";
import ButtonModalCommon from "components/ModalCommon/ButtonModalCommon";
import HelperUseFormula from "./HelperUseFormula";

const reducer = (state, action) => {
  return { ...state, ...action };
};

const defaultValue = {
  defaultLabel: "",
  defaultPosition: "right",
  defaultFormat: "number",
  defaultNumFix: 0,
  defaultFormula: "",
};

const initialState = {
  name: "",
  type: "list",
  open: false,
  value: 0,
  ...defaultValue,
};

const AddColumnModal = React.forwardRef(({ onAddColumns = () => {} }, ref) => {
  const typingTimeoutRef = React.useRef();
  const [dataSearch, setDataSearch] = React.useState([]);
  const [listSources, setListSources] = React.useState([]);
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [state, dispatchState] = React.useReducer(reducer, initialState);
  const refContent = React.useRef(null);
  const [libraryAdded, setLibraryAdded] = React.useState(false);
  const [checkedLibraries, setCheckedLibraries] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [helperTextFormula, setHelperTextFormula] = React.useState(undefined);
  const [helperUseFormula, setHelperUseFormula] = React.useState(false);
  console.log(helperUseFormula, "helperUseFormula");
  const libraryList = useGetLibraryList(state.value === 1);

  const dispatch = useDispatch();
  React.useImperativeHandle(ref, () => ({
    _open: (type, data) => handleClickOpen(type, data),
  }));

  const handleChangeTab = (event, value) => {
    dispatchState({ name: "", value });
    setCheckedLibraries([]);
  };

  const handleClickOpen = (type, data) => {
    dispatchState({ open: true, type, ...data });
  };

  const handleChangeType = (type) => {
    dispatchState({ type, ...defaultValue });
  };

  const handleOpen = (open) => {
    dispatchState({ open });
  };

  const _handleChange = (e) => {
    dispatchState({ name: e.target.value });
  };

  const _handleChangeSearch = (e) => {
    const { value } = e.target;

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      console.log(value);
    }, 500);

    dispatchState({ name: e.target.value });
  };

  const _getDataType = () => {
    switch (state.type) {
      case "hash":
        return 4;
      case "list":
        return 3;
      case "number":
        return 2;
      case "datetime":
        return 5;
      default:
        return 1;
    }
  };

  const _handleConfirm = async () => {
    if (state.value === 1) {
      handleCreateFieldFromLibrary();
    } else {
      handleCreateField();
    }
  };

  const handleCreateField = () => {
    setLoading(true);
    const data_type = _getDataType();
    const contentValue = refContent.current._getValue();
    const data = { project_id: projectId, name: state.name };

    if (data_type !== 4) {
      data["belong_library"] = libraryAdded;
    }

    const dataColumn = {
      id: new Date().getTime(),
      Header: state.name,
    };

    switch (data_type) {
      case 5:
        data["date_time_format"] = contentValue.dateTimeFormat;
        data["data_type"] = 6;
        break;
      case 4:
        data["data_type"] = 4;
        data["position_format"] = contentValue.position_format;
        data["decimal"] = contentValue.decimal;
        data["format"] = contentValue.format;
        data["formula"] = contentValue.formula;
        break;
      case 2:
        if (state.defaultFormat !== "hash" && !contentValue.isHashFormat) {
          data["format"] = contentValue.format;
          data["decimal"] = contentValue.decimal;
          data["position_format"] = contentValue.position_format;
          data["data_type"] = data_type;
        } else {
        }
        break;
      case 3:
        data["options"] = contentValue;
        data["data_type"] = data_type;
        break;
      case 1:
        data["data_type"] = data_type;
        break;
      default:
        break;
    }

    if (state.type === "list") {
      dataColumn["Cell"] = (props) => (
        <CellLabel value={props.value} props={props} />
      );
    }
    dispatch(
      createColumns(
        data,
        () => {
          handleAddColumnsSuccess(data);
          dispatchState(initialState);
        },
        () => {
          handleAddColumnFail();
        }
      )
    );
  };

  const handleAddColumnFail = () => {
    setLoading(false);
  };

  const handleAddColumnsSuccess = (data) => {
    setLoading(false);
    onAddColumns({ data, _id: new Date().getTime() });
  };

  const handleCreateFieldFromLibrary = async () => {
    const request = {
      project_id: projectId,
      fields_id: checkedLibraries,
    };

    const result = await createColFromLibrary(request);
    if (result?.state) {
      dispatch(listColumns({ project_id: projectId }));
      dispatchState(initialState);
    } else {
      SnackbarEmitter(SNACKBAR_VARIANT.ERROR, DEFAULT_MESSAGE.MUTATE.ERROR);
    }
  };

  const handleCheckLibrary = (event, library) => {
    const id = library?.id;
    let list = [...checkedLibraries];
    const checked = event.target.checked;

    if (checked) {
      list?.push(id);
    } else {
      list = list.filter((l) => l !== id);
    }
    setCheckedLibraries(list);
  };

  const canConfirm =
    (state.value === 0 && !!state.name) ||
    (state.value === 1 && checkedLibraries.length > 0);

  return (
    <ModalCommon
      title={t("ADD_FIELDS_DATA")}
      open={state.open}
      setOpen={handleOpen}
      btnActionsRight={[
        <ButtonModalCommon onClick={() => handleOpen(false)}>
          {t("DMH.COMP.CUSTOM_MODAL.CANCLE")}
        </ButtonModalCommon>,
        <ButtonModalCommon
          loading={loading}
          variant="contained"
          onClick={() => _handleConfirm()}
        >
          {t("Complete")}
        </ButtonModalCommon>,
        // <ButtonModalCommon variant="contained">Hoàn thành</ButtonModalCommon>,
      ]}
    >
      <Box
        sx={{
          ...(helperUseFormula
            ? { position: "absolute", right: "-10000px" }
            : {}),
        }}
      >
        <WrapperTabs
          value={state.value}
          onChange={handleChangeTab}
          TabIndicatorProps={{
            style: {
              backgroundColor: "rgb(125,125,125)",
            },
          }}
        >
          <Tab
            // label={isEditForm ? t("update") : t("IDS_WP_CREATE_NEW")}
            label={t("IDS_WP_CREATE_NEW")}
            {...a11yProps(0)}
          />
          {/* {!isEditForm && (
          <Tab label={t("SELECT_FROM_LIBRARY")} {...a11yProps(1)} />
        )} */}
          <Tab label={t("SELECT_FROM_LIBRARY")} {...a11yProps(1)} />
        </WrapperTabs>
        <Box sx={{ flexGrow: 1 }}>
          <TabPanel value={state.value} index={0}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TitleSectionModal label={t("LABEL_CREATE_FIELDS")} />
                <TextField
                  onChange={_handleChange}
                  className="offerModal--titleText"
                  placeholder={t("LABEL_CREATE_FIELDS")}
                  variant="outlined"
                  InputProps={{
                    style: { color: "#666" },
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TitleSectionModal label={t("DATA_TYPES")} />
                <SelectFieldTypeDropdown
                  defaultValue={state.type}
                  onSelect={handleChangeType}
                />
              </Grid>

              <Grid item xs={12}>
                <ToggleInput />
              </Grid>

              <TabContentColumn
                ref={refContent}
                type={state.type}
                defaultLabel={state.defaultLabel}
                defaultPosition={state.defaultPosition}
                defaultFormat={state.defaultFormat}
                defaultNumFix={state.defaultNumFix}
                defaultFormula={state.defaultFormula}
                helperTextFormula={helperTextFormula}
                setHelperTextFormula={setHelperTextFormula}
                setHelperUseFormula={setHelperUseFormula}
                listSources={listSources}
                setListSources={setListSources}
              />

              <Grid item xs={12}>
                <WrapperCheckbox
                  control={
                    <Checkbox
                      name="gilad"
                      onChange={(e) => {
                        setLibraryAdded(e.target.checked);
                      }}
                      disabled={state.type === "hash"}
                    />
                  }
                  label={t("ADD_FILED_TO_LIBRARY")}
                />
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={state.value} index={1}>
            <TextField
              onChange={_handleChangeSearch}
              className="offerModal--titleText"
              placeholder={t("FIND_FIELD_DATA")}
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: <SearchIcon style={{ marginRight: "10px" }} />,
                style: { color: "#666", marginTop: "15px" },
              }}
            />
            {/* show search */}
            {dataSearch.length > 0 && (
              <Box style={{ backgroundColor: "#f1f2f4" }}>
                <List>
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemText primary="Trash" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton component="a" href="#simple-list">
                      <ListItemText primary="Spam" />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Box>
            )}
            {/* show search */}
            <TitleSectionModal label={t("DATA_FIELD_EXITS")} />
            <Grid container>
              {libraryList?.length > 0 &&
                libraryList.map((library) => (
                  <Grid
                    item
                    xs={12}
                    key={library?.id}
                    sx={{
                      background: "#0000000a",
                      padding: "5px 10px",
                      borderRadius: "7px",
                      margin: "5px 0",
                      "&:hover": {
                        background: "#2196f314",
                      },
                    }}
                  >
                    <WrapperCheckbox
                      control={
                        <Checkbox
                          name="gilad"
                          onChange={(e) => handleCheckLibrary(e, library)}
                        />
                      }
                      label={library?.name}
                      name={library?.id}
                      value={library?.id}
                    />
                  </Grid>
                ))}
            </Grid>
          </TabPanel>
        </Box>
      </Box>
      {helperUseFormula && (
        <HelperUseFormula setHelperUseFormula={setHelperUseFormula} />
      )}
    </ModalCommon>
    // <JobDetailModalWrap
    //   title={t("ADD_FIELDS_DATA")}
    //   open={state.open}
    //   setOpen={handleOpen}
    //   confirmRender={() => t("CREATE_FIELDS")}
    //   titleComponent={
    //     <TitleModalAdd
    //       value={state.value}
    //       handleChangeTab={handleChangeTab}
    //       setOpen={handleOpen}
    //     />
    //   }
    //   canConfirm={canConfirm}
    //   className="offerModal"
    //   height={"medium"}
    //   manualClose={true}
    //   onCancle={() => handleOpen(false)}
    //   onConfirm={_handleConfirm}
    //   loading={loading}
    //   actionLoading={loading}
    // >

    // </JobDetailModalWrap>
  );
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const WrapperCheckbox = styled(FormControlLabel)`
  span.Mui-checked {
    color: #4caf50 !important;
  }
`;

const WrapperTabs = styled(Tabs)`
  border-bottom: 1px solid #0000001a;
  .Mui-selected span {
    color: #000000;
    font-weight: 500;
  }
`;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default AddColumnModal;
